import * as Sentry from "@sentry/browser";
import * as React from "react";

if (process.env.NODE_ENV === "production") {
    Sentry.init({
        enabled: true,
        dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
        environment: process.env.ENV
    });
}

// eslint-disable-next-line react/prop-types,@typescript-eslint/ban-ts-ignore
// @ts-ignore
// eslint-disable-next-line react/prop-types
export default function App({ Component, pageProps, err }) {
    // Workaround for https://github.com/vercel/next.js/issues/8592
    return <Component {...pageProps} err={err} />;
}
